import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-membership-single',
  templateUrl: './membership-single.component.html',
  styleUrls: ['./membership-single.component.scss']
})
export class MembershipSingleComponent implements OnInit {

	detailmemberRequest: any = {};
	membershipList: any = "";
	memberSingle: any = {};
	membercontentRequest: any = {};
	bannerList: any = "";
	contentList: any = "";
	bannerrequest: any = {};

  constructor(
	private allpagesService: AllPageService,
	private activatedRoute:ActivatedRoute,
  ) { }
  
  ngOnInit() {

	this.loadBanner();
	this.loadcontent();
	this.allpagesService.getMembership().then((data) => {
		this.membershipList = data;
		//console.log(this.membershipList); 
	});

	

	this.activatedRoute.params.subscribe((data)=>{
		if(data.slug){
		  this.getMembership(data.slug);
		  //this.newsRequest = data.slug;
		}
	  });
  }

  getMembership(memberslug) {
    this.detailmemberRequest.slug = memberslug;
    let request = Object.assign({}, this.detailmemberRequest)
    this.allpagesService.getMembershipDetails(request).then((data) => {
       this.memberSingle = data.data || {};
	   
       
      // console.log(this.memberSingle);
      
      });
  }

  loadBanner() {
	this.bannerrequest = {
		title : 'Membership'
	};
	let request = Object.assign({}, this.bannerrequest);
	this.allpagesService.getBannerList(request).then((data: any) => {
		this.bannerList = data.data[0];
		//console.log(this.bannerList);
	});
}
 
loadcontent(){
	this.membercontentRequest = {
		title: 'Membership Single'
	}
	let request = Object.assign({}, this.membercontentRequest);
	this.allpagesService.getContenttext(request).then((data: any) => {
		this.contentList = data.data[0];
		console.warn(this.contentList);
	});
}

}
